export default __webpack_public_path__ + "static/schema-ru-2c41291084694f92091d44ec1068370f.png";